<template>
      <div class="contactTypeEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'contactType', params: {} }">
          Contact Type
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'contactTypeEdit', params:{id: id} }">
            Edit Contact Type
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Contact Type</v-card-title>
          <v-card-text>
            <contactType-form :id="id"></contactType-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import ContactTypeForm from './ContactTypeForm.vue';

    export default {
      name: 'contactType',
      data () {
        return {
          id: null
        }
      },
      components: {
        ContactTypeForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    